// extracted by mini-css-extract-plugin
export var dividerLine = "_92-3";
export var itemImage = "_92-9";
export var lightDivider = "_92-4";
export var modalContent = "_92-5";
export var modalContentCompact = "_92-6";
export var productCard = "_92-a";
export var productImage = "_92-b";
export var productImageCompact = "_92-7";
export var productImagePlaceholder = "_92-c";
export var productImagePlaceholderCompact = "_92-8";
export var progressBarBackground = "_92-1";
export var progressBarContainer = "_92-0";
export var progressBarFill = "_92-2";